/**
 * @sw-package b2b
 */
import Feature from "src/helper/feature.helper";

interface StorefrontWindow extends Window {
    PluginManager: {
        register: (pluginName: string, plugin: any, selector: string) => void;
    };
}

declare var window: StorefrontWindow;

const PluginManager = window.PluginManager;

if (Feature.isActive('BUDGET_MANAGEMENT')) {
    PluginManager.register('B2bBudgetContent', () => import('./plugin/listing/listing.plugin'), '[data-b2b-budget-content]');
    PluginManager.register('B2bBudgetConfirmModal', () => import('./plugin/confirm-modal/confirm-modal.plugin'), '[data-b2b-budget-confirm-modal]');
    PluginManager.register('B2bBudgetStatistic', () => import('./plugin/budget-statistic.plugin'), '[data-b2b-budget-statistic]');
    PluginManager.register('SingleAjaxSelection', () => import('./plugin/forms/single-ajax-selection.plugin'), '[data-single-ajax-selection]');
    PluginManager.register('B2bBudgetSelection', () => import('./plugin/checkout/b2b-budget-selection.plugin'), '[data-b2b-budget-selection]');
    PluginManager.register('B2bBudgetStorageCleanup', () => import('./plugin/checkout/b2b-budget-storage-cleanup.plugin'));
    PluginManager.register('B2bBudgetRecipients', () => import('./plugin/budget-recipients.plugin'), '[data-b2b-budget-recipients]');
    PluginManager.register('B2bBudgetFormValidation', () => import('./plugin/forms/budget-form-validation.plugin'), '[data-b2b-budget-form-validation]');
}
